<!-- Start Page Title Area -->
<div id="bg-cover" class="page-title-area lightgray-bg jarallax" data-jarallax='{"speed": 0.3}'>
        <div class="container">
            <div class="page-title-content">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li>Knowledge</li>
                </ul>
                <h2>Knowledge</h2>
            </div>
        </div>
    </div>
    <!-- End Page Title Area -->
    <!-- Start Blog Area -->
    <section class="blog-area ptb-100">
        <div class="container">
            <app-small-spinner [show]="showSpinner"></app-small-spinner>
            <div class="row">
                <div class="col-lg-4 col-md-6" *ngFor="let knowledge of knowledges">
                    <app-knowledge-item [knowledge]="knowledge"></app-knowledge-item>
                </div>
                
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="pagination-area text-center">
                        <span class="page-numbers current" aria-current="page">1</span>
                        <a href="#" class="page-numbers">2</a>
                        <a href="#" class="page-numbers">3</a>
                        <a href="#" class="page-numbers">4</a>
                        <a href="#" class="page-numbers">5</a>
                        <a href="#" class="next page-numbers"><i class='bx bx-chevron-right'></i></a>
                    </div>
                </div> -->
            </div>
            <div
                *ngIf="loadingMore"
                class="course-loader"
            >
                <div class="loader-spinner">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div class="loader-text">
                    <strong>Loading more courses</strong>
                    <small>Please wait a moment...</small>
                </div>
            </div>

            <!-- No More Courses -->
            <div
                *ngIf="!hasNextPage && knowledges.length > 0"
                class="no-more-courses"
            >
                <div class="no-more-line"></div>

                <div class="no-more-content">
                    <i class="fa fa-check-circle"></i>
                    <span>You've reached the end</span>
                </div>

                <div class="no-more-line"></div>
            </div>
        </div>
    </section>
    <!-- End Blog Area -->
